import Link from 'next/link'
import React, { FC } from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { FloatingItem } from '@/types/apps'

interface InterfaceMenuItems {
  item: FloatingItem
}
const MenuItems: FC<InterfaceMenuItems> = ({ item }) => {
  return (
    <div className='floating__item-container'>
      <div className='floating__item-text-outside'>{item.title}</div>
      <div className='floating__item'>
        <div className='floating__item-text'>{item.title}</div>
        <ImageByWidthDevice
          images={item.imageFiles}
          alt={item.title}
          className='floating__item-icon'
        />
        <Link href={item.url} />
      </div>
    </div>
  )
}

export default MenuItems
